import React, { useEffect, useMemo, useRef } from "react";
import { useLocation, useNavigate } from 'react-router-dom'
import { Button, ButtonGroup, DropDownButton, DropDownButtonItemClickEvent } from "@progress/kendo-react-buttons";
import { Trans } from "react-i18next";
import { t } from "i18next";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { SvgIcon } from "@progress/kendo-react-common";
import * as svgIcons from "@progress/kendo-svg-icons";
import { Tooltip } from "@progress/kendo-react-tooltip";
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  CardSubtitle,
  Avatar,
} from "@progress/kendo-react-layout";
import { ODataProvider } from "../../contexts/ODataContext";
import DataGridCustom, { ColumnCustomProps, DataGridHandle } from "../../components/DataGridCustom";
import config from "../../contexts/ConfigContext";
import { PermissionButton } from "../../components/PermissionButton";
import { GridCellProps, GridRowClickEvent } from "@progress/kendo-react-grid";
import { WindowLabeling } from "../../components/WindowLabeling";
import { BatchService, LabelingModel, DocumentModel } from "../../services/BatchServices";
import { AnnotationModel, AnnotationService } from "../../services/Annotation";
import { CommentService } from "services/CommentService";
import moment from "moment";
import {moreHorizontalIcon, copyIcon, pencilIcon, trashIcon, commentIcon, dataIcon, clockIcon } from "@progress/kendo-svg-icons";
import {CommonLibrary} from '../../contexts/CommonContext';
import { useActiveProject } from '../../contexts/ActiveProjectContext';
import { useNotification } from '../../contexts/NotificationContext';
import {DropDownGridCell} from "../../components/DropDownGridCell";
import { DropDownGridCellHandle } from "../../components/DropDownGridCell";
import { Switch, SwitchChangeEvent } from "@progress/kendo-react-inputs";
import { usePermissionContext } from "../../contexts/PermissionContext";
import { SearchService } from "../../services/SearchService";
import { SearchMissingsService } from "../../services/Missings/SearchMissingsService";
import { ConfirmModal } from "../../components/ConfirmModal";
import { useLoadingPanel } from "../../contexts/LoadingContext";
import { ExpansionPanel, ExpansionPanelContent, ExpansionPanelActionEvent } from '@progress/kendo-react-layout';
import { Reveal } from '@progress/kendo-react-animation';
import { CommentSection } from '../../components/DataLabeling/Labeling/CommentsViewComponent';
import 'bootstrap-icons/font/bootstrap-icons.css';
import ImagesGalleryComponent from "components/DataLabeling/Labeling/ImagesGalleryComponent";
import { MetadataSection } from "components/DataLabeling/Labeling/MetadataComponent";
import { AuditEntryModal } from "components/History Tracking/AuditComponent";

const Labeling = () => {
  const notifications = useNotification();
  var loadingPanel = useLoadingPanel();
  const comonLibrary = new CommonLibrary();
  const { project: activeProject, status: projectStatus } = useActiveProject();
  // Get state from location
  const location = useLocation()
  const { from } = location.state? location.state : { from: { operation: "search", batchId: 0, documentId: 0 } };
  const navigate = useNavigate();
  const initialState = from;
  const [fromState, setFromState] = React.useState(initialState);
  const { permission} = usePermissionContext();
  const permissionQAReview = permission.find((p:any) => p.Code === "qa_review");
  const hasAuditHistoryPermission = permission.find((p:any) => p.Code === "audit_history_annotations");
  // Define the batch service
  const batchService = new BatchService();
  const annotationService = new AnnotationService();
  const searchService = new SearchService();
  const commentService = new CommentService();
  const missingsService = new SearchMissingsService();
  const editField = "inEdit";
  const annotationsGridPageSize = 1000;
  const lockEntityEdit = comonLibrary.LockedPreAnnotatedEntity;
  const showDocumentChangedBadge= comonLibrary.ShowDocumentChangedBadge;
  const[editInlineInProgress, setEditInlineInProgress] = React.useState<boolean>(false);
  const[selectedEntityItem, setSelectedEntityItem] = React.useState<any>(null);
  const[preSelectedEntityItem, setPreSelectedEntityItem] = React.useState<any>(null);
  const[selectedLabelItem, setSelectedLabelItem] = React.useState<any>(null);
  const dropDownEntityRef = React.useRef<DropDownGridCellHandle>(null);
        
  const [show, setShow] = React.useState(false);  
  const [showNextBatch, setShowNextBatch] = React.useState(false);
  const [selectedAnnotationId, setAnnotationId] = React.useState<number>(0);
  const [openForm, setOpenForm] = React.useState<boolean>(false);
  const [isAnnotationChangeLoading, setIsAnnotationChangeLoading] = React.useState(false);
  const [isCardDataLoading, setIsCardDataLoading] = React.useState(false);
  const [editItem, setEditItem] = React.useState<any>(null);
  const [nextStatus, setNextStatus] = React.useState<number>(0);
  const [cardData, setCardData] = React.useState<DocumentModel>({} as DocumentModel);
  const [formMode, setFormMode] = React.useState<string>("");
 const [isDropDownDisabled, setIsDropDownDisabled] = React.useState<boolean>(false);

  const entityApiUrl = config.API_URL + "/odata/ProjectEntities/";
  const annotationsApiUrl = config.API_LABELING_URL + "/odata/Annotations/";
  const labelApiUrl = config.API_LABELING_URL + "/odata/AnnotationEntityLabels";
  const dataGridRef = useRef<DataGridHandle>(null);

  const [currentBatch, setCurrentBatch] = React.useState<LabelingModel>({} as LabelingModel);
  const [expandedTextToSpeech, setExpandedTextToSpeech] = React.useState(t('general.subtitle') as string);
  const [expandedComments, setExpandedComments] = React.useState(t('general.authorComments') as string);
  const [expandedHashtagsAndMentions, setExpandedHashtagsAndMentions] = React.useState(t('dataLabeling.labeling.hashtagsMentions') as string);

  const [showComments, setShowComments] = React.useState(false);
  const [comments, setComments] = React.useState<any[]>([]);
  const [typeId, setTypeId] = React.useState(0); //0 for Annotation - 1 for Document
  const [documentId, setDocumentId] = React.useState<number>(0);

  const [showMetadata, setShowMetadata] = React.useState(false);
  const [metadata, setMetadata] = React.useState<any>(null);
  const [auditHistory, setAuditHistory] = React.useState<any>([]);
  const [showAuditHistory, setShowAuditHistory] = React.useState(false);

  const closeCommentsWindow = () => {
    setShowComments(false)
  }

  const closeMetadataWindow = () => {
    setShowMetadata(false)
  }

  const closeAuditHistoryWindow = () => {
    setShowAuditHistory(false)
  }

  useEffect(() => {
    const storedDocumentId = localStorage.getItem("documentId");
    if (storedDocumentId) {
      const storedOperation = localStorage.getItem("operation");
      if(storedOperation ==="missing"){
        location.state = { from: { ...fromState, operation: storedOperation, documentId: parseInt(storedDocumentId, 10), batchId: 0 } };
      }else{
        location.state = { from: { ...fromState, operation: "search", documentId: parseInt(storedDocumentId, 10) } };
      }
      localStorage.removeItem("operation");
      localStorage.removeItem("documentId");
    }
  }, []);

  // Update the state from the location
  useEffect(() => {
    if (location.state?.from) {
      setFromState((prevState: any) => ({
        ...prevState,
        ...location.state.from, // Merge new state into the existing one
      }));
    }
  }, [location.state]);

  useEffect(() => {
   if (location.state?.from.operation === "resume") {
    //IF the documentId is present, it means the user is refreshing the page
      if(location.state?.from.documentId){
        // Call the API to work the document
        workDocument(location.state?.from.documentId);

      }
      //If the documentId is not present, it means the user is resuming the batch ariving from dashboard
      else{
        // Call the API to resume the batch
        loadingPanel.show("#root");
        batchService.ResumeBatch(from.batchId, from.sourceType).then((batchWork) => {
          setCurrentBatch(batchWork);
          getDocumentAnnotations(batchWork.CurrentDocument.Id);
          checkDocumentStatus(batchWork.CurrentDocument.Id);
          handleStateChange(batchWork.CurrentDocument.Id);
          setCardData(batchWork.CurrentDocument);
          
          batchService.WorkBatch(batchWork).then((batchWork) => {
            // Set the card data of the current document
            setCardData(batchWork.CurrentDocument);
          }).finally(() => {
            setIsCardDataLoading(false);
          })
        }).finally(() => {
          loadingPanel.hide();
        });
      }
    }
    else if (location.state?.from.operation === "work") {
      //IF the documentId is present, it means the user is refreshing the page
      if(location.state?.from.documentId){
        // Call the API to work the document
        workDocument(location.state?.from.documentId);

      }
      //If the documentId is not present, it means the user is resuming the batch ariving from dashboard
      else{
      workDocument();   
      }     
    }
    else if(location.state?.from.operation ==="search"){
      // Call the API to browse ducuments found on search results
      browseDocument(location.state?.from.documentId);
    
    }else if(location.state?.from.operation ==="missing"){
      LoadMissingDocument(location.state?.from.documentId);
    }
  }, [from.batchId]);

 
  // Method to handle the state change
  const handleStateChange = (document: number | null , batchId : number | null = null) => {
    batchId = batchId ?? from.batchId;
    const updatedState = {
      ...fromState, // Preserve existing properties
      batchId: batchId, // Update only the batchId
      documentId: document, // Update only the documentId
    };

    setFromState(updatedState); // Update local state

    // Update the URL and state in navigation
    navigate(`/dashboard/labeling`, {
      replace: true, // Avoid adding extra history entries
      state: { from: updatedState }, // Keep the updated state structure
    });
  };

  //Laoding the "batch" data for labeling functionality
  const workDocument = (documentId?: number) => {
    // Call the API to work the document
    setEditInlineInProgress(false);
    loadingPanel.show("#root");
    setIsCardDataLoading(true);
    batchService.GetCurrentDocument(from.batchId, documentId).then((batchWork) => {
      setCurrentBatch(batchWork);
      getDocumentAnnotations(batchWork.CurrentDocument.Id);
      checkDocumentStatus(batchWork.CurrentDocument.Id);
      handleStateChange(batchWork.CurrentDocument.Id);
      setCardData(batchWork.CurrentDocument);
      
      batchService.WorkBatch(batchWork).then((batchWork) => {
        // Set the card data of the current document
        setCardData(batchWork.CurrentDocument);
      }).finally(() => {
        setIsCardDataLoading(false);
      })
    }).finally(() => {
      loadingPanel.hide();
    });
  }
//Laoding the "batch" data for the Search functionality
  const LoadMissingDocument = (documentId? : number) => {
    // Call the API to get the document
    setEditInlineInProgress(false);
    loadingPanel.show("#root");
    setIsCardDataLoading(true);
    missingsService.GetDocument(documentId).then((labelingModel) => {
      setCurrentBatch(labelingModel);
      getDocumentAnnotations(labelingModel.CurrentDocument.Id);
      labelingModel.CurrentDocument.Id && checkDocumentStatus(labelingModel.CurrentDocument.Id);
      handleStateChange(labelingModel.CurrentDocument.Id);
      setCardData(labelingModel.CurrentDocument);
      
      missingsService.EnrichDocument(labelingModel).then((enrichedLabelingModel) => {
        // Set the card data of the current document
        setCardData(enrichedLabelingModel.CurrentDocument);
      }).finally(() => {
        setIsCardDataLoading(false);
      })
    }).finally(() => {
      loadingPanel.hide();
    });
  }
  //Laoding the "batch" data for the Search functionality
  const browseDocument = (documentId? : number) => {
    // Call the API to get the document
    setEditInlineInProgress(false);
    loadingPanel.show("#root");
    setIsCardDataLoading(true);
    searchService.BrowseResults(documentId).then((labelingModel) => {
      setCurrentBatch(labelingModel);
      getDocumentAnnotations(labelingModel.CurrentDocument.Id);
      labelingModel.CurrentDocument.Id && checkDocumentStatus(labelingModel.CurrentDocument.Id);
      handleStateChange(labelingModel.CurrentDocument.Id);
      setCardData(labelingModel.CurrentDocument);
      
      searchService.BrowseResultsEnricher(labelingModel).then((enrichedLabelingModel) => {
        // Set the card data of the current document
        setCardData(enrichedLabelingModel.CurrentDocument);
      }).finally(() => {
        setIsCardDataLoading(false);
      })
    }).finally(() => {
      loadingPanel.hide();
    });
  }

  //Laoding the "batch" data for the next document for labeling functionality
  const nextDocument = (documentId : number) => {
    // Call the API to get the next document
    setEditInlineInProgress(false);
    loadingPanel.show("#root");
    setIsCardDataLoading(true);
    annotationService.SetDocumentStatus(cardData.Id, 2).then((result) => {
      // Set the card data of the current document
      batchService.GetCurrentDocument(from.batchId, documentId).then((batchWork) => {
        setCurrentBatch(batchWork);
        getDocumentAnnotations(batchWork.CurrentDocument.Id);
        checkDocumentStatus(batchWork.CurrentDocument.Id);
        handleStateChange(batchWork.CurrentDocument.Id);
        setCardData(batchWork.CurrentDocument);

        batchService.WorkBatch(batchWork).then((batchWork) => {
          // Set the card data of the current document
          setCardData(batchWork.CurrentDocument);
        }).finally(() => {
          setIsCardDataLoading(false);
        })
      }).finally(() => {
        loadingPanel.hide();
      });
  });
}

const skipDocument = (documentId : number) => {
  // Call the API to get the next document
  setEditInlineInProgress(false);
  loadingPanel.show("#root");
  setIsCardDataLoading(true);
  annotationService.SetDocumentStatus(cardData.Id, 3).then((result) => {
    if(documentId){
    // Set the card data of the current document
    batchService.GetCurrentDocument(from.batchId, documentId).then((batchWork) => {
      setCurrentBatch(batchWork);
      getDocumentAnnotations(batchWork.CurrentDocument.Id);
      checkDocumentStatus(batchWork.CurrentDocument.Id);
      handleStateChange(batchWork.CurrentDocument.Id);
      setCardData(batchWork.CurrentDocument);

      batchService.WorkBatch(batchWork).then((batchWork) => {
        // Set the card data of the current document
        setCardData(batchWork.CurrentDocument);
      }).finally(() => {
        setIsCardDataLoading(false);
      })
    }).finally(() => {
      loadingPanel.hide();
    });
  }
  else{
    navigate("/dashboard");
  }
}).finally(() => {
  loadingPanel.hide();
});
}

//Handle the last ordered document of the batch
  const completeLastDocument = () => {
    setEditInlineInProgress(false);
    // Call the API to start a new batch
    annotationService.SetDocumentStatus(cardData.Id, 2).then((result) => {
      if (location.state?.from.operation === "missing") {
        setShowNextBatch(false);
        handleNextBatchConfirm(from.batchId);
      }
      else {
        setShowNextBatch(true);
      }
    });
      
  }
  const saveDocument =() => {
    annotationService.SetDocumentStatus(cardData.Id, 2).then((result) => {
      browseDocument(currentBatch.CurrentDocument.Id);
    });
  }
  
  const getDocumentStatusBadge = (statusId: number) => {
    switch (statusId) {
      case 1:
        return "badge-in-progress";
      case 2:
        return "badge-completed";
      case 3:
        return "badge-skipped";     
    }
  }
  // Method to get document annotations
  const getDocumentAnnotations = (documentId: number) => {
    dataGridRef.current?.filterData(
      {
        logic: "and",
        filters: [
          {
            field: "DocumentId",
            operator: "eq",
            value: documentId
          }
        ]
      }
    );

    dataGridRef.current?.orderData([{ field: "Entity", dir: "asc" }]);
  }

  // Method to check Status of the document
  const checkDocumentStatus = async (documentId: number) => {
    await annotationService.CheckDocumentStatus(documentId).then((result) => {
      setNextStatus(result);
    });

  }

  // Event handlers of the ComandCell Events (Edit/Clone/Comment/Remove)
  const handleDomEvent = (e: DropDownButtonItemClickEvent, dataItem: any)=> {
    switch (e.item.label) {
      case "Edit":
          editMethod(dataItem);
        break;
      case "Clone":
          cloneAnnotation(dataItem.AnnotationId);
        break;
      case "Comment":
          openComments(dataItem);
        break;
      case "Metadata":
          openMetadata(dataItem);
        break;
      case "History":
          openAuditHistory(dataItem.AnnotationId);
          break;
      case "Remove":  
          setAnnotationId(dataItem.AnnotationId);      
          setShow(true);
        break;
    } 
  }

  // Delete annotation event handler
 const deleteAnnotation = () => {
    annotationService.DeleteAnnotation(selectedAnnotationId).then((result) => {
      getDocumentAnnotations(cardData.Id);
      checkDocumentStatus(cardData.Id);
      setEditInlineInProgress(false);
    });
  }

  // Clone annotation event handler
  const cloneAnnotation = (annotationId: number) => {
    annotationService.CloneAnnotation(annotationId).then((result) => {
      getDocumentAnnotations(cardData.Id);
      checkDocumentStatus(cardData.Id);
       setEditInlineInProgress(false);
    });
  }

  // Row click event handler
  const handleRowClick = (event: GridRowClickEvent)=> {
    let inlineEditMode = comonLibrary.InlineEdit;
    //If the project is configured to edit inline, clicking on the row will enter inline edit mode otherwise it will open the edit form
    if(inlineEditMode){
    enterInlineEdit(event.dataItem);
    }
    else{
    editMethod(event.dataItem);
    }
  }
  // Enter inline edit event handler
  const enterInlineEdit = (dataItem: any) => {
    if(!editInlineInProgress){
      setEditInlineInProgress(true);
      dataGridRef.current?.editInline(dataItem.AnnotationId);
      annotationService.GetAnnotationLabels(dataItem.AnnotationId).then((result:any) => {
        setSelectedEntityItem({EntityId: result.EntityId, Description: result.Entity});
        setPreSelectedEntityItem({EntityId: result.EntityId, Description: result.Entity});
        if (result.AnnotationLabels.length > 0)
          setSelectedLabelItem({LabelId: result.AnnotationLabels[0].LabelId, LabelDescription: result.AnnotationLabels[0].Label});
      });
    }
  };
// Edit form 
  const editMethod = (dataItem: any) => {
    setFormMode("edit");
        annotationService.GetAnnotationLabels(dataItem.AnnotationId).then((result) => {
          const item = {
            Id: result.Id,
            entity_dropdown: {
              EntityId: result.EntityId,
              Description: result.Entity
            },
            label_dropdown:   (result.AnnotationLabels[0]) ? {LabelId: result.AnnotationLabels[0].LabelId, LabelDescription: result.AnnotationLabels[0].Label}: null,      
            label_dropdown_2: (result.AnnotationLabels[1]) ? {LabelId: result.AnnotationLabels[1].LabelId, LabelDescription: result.AnnotationLabels[1].Label}: null,
            label_dropdown_3: (result.AnnotationLabels[2]) ? {LabelId: result.AnnotationLabels[2].LabelId, LabelDescription: result.AnnotationLabels[2].Label} : null
          }
          setEditItem(item);
          setOpenForm(true);
          setIsDropDownDisabled(lockEntityEdit && !dataItem.CanDelete);
        });
  }

  //Open comments
  const openComments = (dataItem: any) => {
    setTypeId(0);
    setAnnotationId(dataItem.AnnotationId);
    setDocumentId(dataItem.DocumentId);
    commentService.GetComments(typeId, dataItem.AnnotationId).then((result) => {
      const mapped = result.map(item => ({
        id: item.CommentId,
        content: item.CommentContent?.toString() ?? '',
        annotationId: item.AnnotationId ?? null,
        documentId: item.DocumentId ?? null,
        firstName: item.FirstName?.toString() ?? '',
        lastName: item.LastName?.toString() ?? '',
        createdBy: item.CreatedBy ?? null,
        lastUpdatedDate: item.LastUpdateDate?.toString() ?? ''
      }));
      setShowComments(true);
      setComments(mapped);
    });
  } 

    //Open external metadata
    const openMetadata = (dataItem: any) => {
      annotationService.GetAnnotationMetadata(dataItem.AnnotationId).then((result) => {
        setMetadata(result);
        setShowMetadata(true);
      })
      .catch((error) => {
        notifications.showNotification("Failed to load annotation metadata", 'error');
      });
    } 

  const openAuditHistory = (annotationId: number) => {
    annotationService.GetAudit(annotationId).then((result) => {
      setAuditHistory(result);
      setShowAuditHistory(true);
    })
    .catch((error) => {
      notifications.showNotification("Failed to load annotation audit history", error);
    });
  } 

  // Check label event handler 
  const handleCheck = (props: any) => {
    setIsAnnotationChangeLoading(true);
    const status = (props.dataItem.StatusId === 1) ? 0 : 1;
    annotationService.SetAnnotationStatus(props.dataItem.AnnotationId, status).then((result) => {
      getDocumentAnnotations(cardData.Id);
      checkDocumentStatus(cardData.Id);
      //If the annotation is unchecked, update the document status InProgress
      if(status === 0 || nextStatus === 0){
        setCardData({...cardData, Status: 1, StatusLabel: "In Progress"});
      }
      setIsAnnotationChangeLoading(false);
    });
    setEditInlineInProgress(false);
  }

  //Mark annotion as need help
  const handleIsFlagged = (props: any) => {
    //Flip current value
    const newIsFlaggedValue = !props.dataItem.IsFlagged;
    annotationService.SetIsFlagged(props.dataItem.AnnotationId, newIsFlaggedValue).then((result) => {
      getDocumentAnnotations(cardData.Id);
      checkDocumentStatus(cardData.Id);
    });
    setEditInlineInProgress(false);
  }

  // Delete label event handler
  const handleDelete = (props: any) => {
    setIsAnnotationChangeLoading(true);
    const status = (props.dataItem.StatusId === 2) ? 0 : 2;
    annotationService.SetAnnotationStatus(props.dataItem.AnnotationId, status).then((result) => {
      getDocumentAnnotations(cardData.Id);
      checkDocumentStatus(cardData.Id);
      //If the annotation is unchecked, update the document status InProgress
      if(status === 0 || nextStatus === 0){
        setCardData({...cardData, Status: 1, StatusLabel: "In Progress"});
      }
      setIsAnnotationChangeLoading(false);
    });
    setEditInlineInProgress(false);
  }

  // QA review event handler
  const handleQAreview = (e:SwitchChangeEvent, props: any) => {
    const checkedQAReview = e.target.value;
    annotationService.SetQAReview(props.dataItem.AnnotationId, checkedQAReview)
    .then((result) => {
      getDocumentAnnotations(cardData.Id);
      checkDocumentStatus(cardData.Id);
    })
    .catch((error) => {
     
    });
    setEditInlineInProgress(false);
  }
  
  // New label event handler
  const handleNew = () => {
    setFormMode("new");
    setOpenForm(true);
    setEditItem(null);
  }

  //Set the SVG icons for the drop down button
  const itemRender = (props: { item: any; itemIndex: number }) => {
    let fileIcon = null;   
    if (props.item.label === "Edit") {
      fileIcon = pencilIcon;
    } else if (props.item.label === "Clone") {
      fileIcon = copyIcon;
    } else if (props.item.label === "Comment"){
      fileIcon = commentIcon;
    } else if (props.item.label === "Metadata"){
      fileIcon = dataIcon;
    } else if (props.item.label === "History"){
      fileIcon = clockIcon;
    } else {
      fileIcon = trashIcon;
    }
  
    return (
      <div>        
        {props.item.label && <SvgIcon icon={fileIcon}/>} 
        {` ${props.item.label}`}      
      </div>
    );
  };

  // Update annotation event handler for the inline edit
  const update = async (dataItem: any) => {
    // Create the annotation object
    if(!selectedLabelItem || selectedLabelItem.LabelId === undefined)
    {
      notifications.showNotification("Please select a label", 'warning');
      return;
    }
    const annotation: AnnotationModel =
    {
      Id: dataItem.AnnotationId,
      DocumentId: cardData.Id,
      EntityId: selectedEntityItem.EntityId,
      Entity: selectedEntityItem.Description,
      StatusId: 0,
      IsFlagged: dataItem.IsFlagged,
      AnnotationLabels: []
    }
    if(selectedLabelItem){
      annotation.AnnotationLabels.push(
        {
          LabelId: selectedLabelItem.LabelId,
          Label: selectedLabelItem.LabelDescription,
          AnnotationId: dataItem.AnnotationId
        });
    }
    annotationService.UpdateAnnotation(annotation).then((result) => {
      getDocumentAnnotations(cardData.Id);
      setEditInlineInProgress(false);
      checkDocumentStatus(cardData.Id);
      if(nextStatus === 0){
        setCardData({...cardData, Status: 1, StatusLabel: "In Progress"});
      }
      
    });
   
  };

  const cancel = (dataItem: any) => {
    dataGridRef.current?.cancelEditInline(dataItem.AnnotationId)
    setSelectedEntityItem(null);
    setSelectedLabelItem(null);
    setEditInlineInProgress(false);
  };
 


  // Handle the entity change event
  const handleEntityChange = (e: any) => {
    setSelectedEntityItem({EntityId:e.value?.EntityId, Description: e.value?.Description});
    setSelectedLabelItem({});
    dropDownEntityRef.current?.setValue({EntityId:e.value?.EntityId, Description: e.value?.Description});
    e.nativeEvent.preventDefault();
     
  };

  // Handle the label change event
  const handleLabelChange = (e: any) => {
    setSelectedLabelItem({
      LabelId: e.value?.LabelId,
      LabelDescription: e.value?.LabelDescription
    });
    e.nativeEvent.preventDefault();
  };

  const handelDataStateChange = () => {
   if(editInlineInProgress){
    setEditInlineInProgress(false);
   }
  }

  const commandCellProps = {
    edit: enterInlineEdit,
    update: update,
    cancel: cancel,
    editField: editField,
  };

  // Define the columns
  const CommandCell = (props: any) => {
    const { editField } = props;
    return (
      <>
      {editField && props.dataItem[editField] ? (
        <td style={{ textAlign: "center" }}>
          <ButtonGroup>
          
          <span className="button-grid">
            <PermissionButton code="menu_datalabeling" mode="edit">
            <Tooltip
            anchorElement="target"
            position="top"
            parentTitle={true}
          >
              <Button fillMode="outline" 
                        title="Cancel"
                        themeColor={"secondary"}
                        onClick={(e) => props.cancel(props.dataItem)} >
               <Trans>Cancel</Trans>
              </Button>
              </Tooltip>
            </PermissionButton>
          </span>
          <span className="button-grid">
            <PermissionButton code="menu_datalabeling" mode="edit">
            <Tooltip
                      anchorElement="target"
                      position="top"
                      parentTitle={true}
                    >
              <Button  fillMode="outline"
                        title="Save"
                        themeColor={"primary"}
                        onClick={(e) => props.update(props.dataItem)} >
               <Trans>Save</Trans>
              </Button>
              </Tooltip>
            </PermissionButton>
          </span>
          </ButtonGroup>
        </td>

  ) : (
    <td style={{ textAlign: "center" }}>    
      <ButtonGroup>
        <span className="button-grid command-cell">
          <PermissionButton code="menu_datalabeling" mode="edit">
            <Button togglable={true} selected={props.dataItem.IsFlagged === true} title={t("dataLabeling.labeling.markAsFlagged")} fillMode="flat" className={props.dataItem.IsFlagged === true ? "icon-warning" : "icon-muted"} onClick={() => handleIsFlagged(props)} >
              {props.dataItem.IsFlagged === true ? (<i className="bi bi-bookmark-fill fs-5"></i>) : (<i className="bi bi-bookmark fs-5"></i>)}
            </Button>
          </PermissionButton>
        </span>
        <span className="button-grid command-cell">
          <PermissionButton code="menu_datalabeling" mode="edit">
            <Tooltip
              anchorElement="target"
              position="top"
              parentTitle={true}>
              <Button togglable={true} selected={props.dataItem.StatusId === 2} title={t("dataLabeling.labeling.marcWrong")} fillMode="outline" themeColor="error" onClick={() => handleDelete(props)} >
                {props.dataItem.StatusId === 2 ? (<SvgIcon icon={svgIcons.xIcon} size="xlarge" />) : (<SvgIcon icon={svgIcons.xIcon} size="xlarge" />)}
              </Button>
            </Tooltip>
          </PermissionButton>
        </span>
        <span className="button-grid command-cell">
          <PermissionButton code="menu_datalabeling" mode="edit">
            <Tooltip
              anchorElement="target"
              position="top"
              parentTitle={true}>
              <Button togglable={true} selected={props.dataItem.StatusId === 1} title={t("dataLabeling.labeling.marcCorrect")} fillMode={"outline"} themeColor="primary" onClick={() => handleCheck(props)} >
                {props.dataItem.StatusId === 1 ? (<SvgIcon icon={svgIcons.checkIcon} size="xlarge" />) : (<SvgIcon icon={svgIcons.checkIcon} size="xlarge" />)}
              </Button>
            </Tooltip>
          </PermissionButton>
        </span>
        <span className="button-grid">
          <DropDownButton
            className="svg-button"
            svgIcon={moreHorizontalIcon}
            items={[
              { label: "Edit", disabled: false },
              { label: "Clone", disabled: false },
              { label: "Comment", disabled: false },
              { label: "Metadata", disabled: false },
              { label: "History", disabled: !hasAuditHistoryPermission?.CanEdit },
              { label: "Remove", disabled: !props.dataItem.CanDelete }
            ]}
            itemRender={itemRender}
            themeColor={"secondary"}
            fillMode={"outline"}
            onItemClick={(e: DropDownButtonItemClickEvent) => handleDomEvent(e, props.dataItem)}
          />
        </span>
      </ButtonGroup>
    </td>)}
  </>
  )};

  // QA review cell
  const QACell = (props: any) => {
    return (
      <td>
        <span>
          <Switch checked={props.dataItem.EnableQAReview} onChange={(e) => handleQAreview(e, props)} value={props.dataItem.EnableQAReview} size="small"/>
        </span>
      </td>
    );
  }
const copyEntityName = (props: any) => {
  navigator.clipboard.writeText(props.dataItem.Entity);
  notifications.showNotification(t("dataLabeling.labeling.entityCopiedNotification"), 'info');
}
  // Icons cell (Lock, Comments)
  const iconCell = (props: any) => {
    const showLock = !props.dataItem.CanDelete && lockEntityEdit;
    const showComment = props.dataItem.HasComments;
  
    return (    
        <td>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 4 }}>
          <span 
            title={t("dataLabeling.labeling.copyEntityName")}
            onClick={() => copyEntityName(props)}
            style={{ cursor: "pointer" }}>
            <SvgIcon style={{ marginBottom: 4 }} icon={svgIcons.copyIcon} size="small" themeColor={"inherit"} />
          </span>
          {showLock && (
            <span title={t("dataLabeling.labeling.pre-annotatedEntityCouldNotBeEdited")}><SvgIcon style={{marginBottom:4}} icon={svgIcons.lockIcon} size="small" themeColor={"inherit"} /></span>
          )}
          {showComment && (
            <span title={t("dataLabeling.labeling.ThereAreCommentsOnThisAnnotation")}><SvgIcon style={{ marginBottom: 4 }} icon={svgIcons.smsSolidIcon} size="small" themeColor={"inherit"} /></span>
          )}
          </div>
        </td>
    );
  };
  
  const columns = [] as ColumnCustomProps[];
  const entityCell = useMemo(() => (props: GridCellProps) => 
    <DropDownGridCell {...getInlineDropDownProps(
      entityApiUrl, 
      "EntityId", 
      "Description",
       handleEntityChange, 
       selectedEntityItem, 
       lockEntityEdit, 
       "", 
       "", 
       true, 
       props,
       dropDownEntityRef)} />,
   [preSelectedEntityItem]);
  const labelCell = useMemo(() =>  (props: GridCellProps) => 
    <DropDownGridCell {...getInlineDropDownProps(
      labelApiUrl, 
      "LabelId", 
      "LabelDescription", 
      handleLabelChange, 
      selectedLabelItem, 
      false, 
      "entityId", 
      selectedEntityItem ? selectedEntityItem.EntityId : "", 
      false, 
      props, 
      null)} />, 
    [selectedEntityItem]);
  columns.push({ cell: iconCell, isExportable: false});
  columns.push({ field: "Entity", cell: entityCell, title: t("configuration.entities.title"), columnMenu: undefined, isExportable: true});
  columns.push({ field: "Labels", cell: labelCell, title: t("configuration.labels.title"), columnMenu: undefined, isExportable: true});
  // QA review column, if the user has the permission
  if (permissionQAReview) {columns.push({cell: QACell, title: t("dataLabeling.labeling.qAReviewColumn"), isExportable: true});}
  columns.push({ cell: (props) => <CommandCell {...props} {...commandCellProps}/> , isExportable: false });
  const handleConfirm = () => {
    deleteAnnotation();
    setShow(false);
  }
  //Start the next availablebatch event handler
  const handleNextBatchConfirm = (currentBatchId: number) => {
    batchService.StartNextBatch(currentBatchId).then((batchWorkId: number) => {
      //Change the state to the next batch
      handleStateChange(null, batchWorkId);
      setShowNextBatch(false);
    }
  ).catch((error) => {
    setShowNextBatch(false);
    navigate("/dashboard");
  });
    
  }

  const handleCloseNextBatch = () => {
    setShowNextBatch(false);
    navigate("/dashboard");
  }

  // Window events
  const handleCancelEdit = () => {
    setOpenForm(false);
  };

  const handleSubmit = (dataItem: any) => {

    // Create the annotation object
    const annotation: AnnotationModel =
    {
      Id: dataItem.Id,
      DocumentId: cardData.Id,
      EntityId: dataItem.entity_dropdown.EntityId,
      Entity: dataItem.entity_dropdown.Description,
      StatusId: 0,
      IsFlagged: dataItem.IsFlagged,
      AnnotationLabels: []
    }
    if(dataItem.label_dropdown){
      annotation.AnnotationLabels.push(
        {
          LabelId: dataItem.label_dropdown.LabelId,
          Label: dataItem.label_dropdown.LabelDescription,
          AnnotationId: dataItem.Id
        });
    }
    if(dataItem.label_dropdown_2){
      annotation.AnnotationLabels.push(
        {
          LabelId: dataItem.label_dropdown_2.LabelId,
          Label: dataItem.label_dropdown_2.LabelDescription,
          AnnotationId: dataItem.Id
        });
    }
    if(dataItem.label_dropdown_3){
      annotation.AnnotationLabels.push(
        {
          LabelId: dataItem.label_dropdown_3.LabelId,
          Label: dataItem.label_dropdown_3.LabelDescription,
          AnnotationId: dataItem.Id
        });
    }

    if (formMode === "new") {
      
      // Call the API to add the annotation
      annotationService.AddAnnotation(annotation).then((result) => {
        getDocumentAnnotations(cardData.Id);
        checkDocumentStatus(cardData.Id);
        setOpenForm(false);
        setEditInlineInProgress(false);
       if(nextStatus === 0){
          setCardData({...cardData, Status: 1, StatusLabel: "In Progress"});
        }
      });
    }
    else {     
      // Call the API to update the annotation      
      annotationService.UpdateAnnotation(annotation).then((result) => {
        getDocumentAnnotations(cardData.Id);
        checkDocumentStatus(cardData.Id);
        setOpenForm(false);
        setEditInlineInProgress(false);
        if(nextStatus === 0){
          setCardData({...cardData, Status: 1, StatusLabel: "In Progress"});
        }
      });
     
    }    
  };

 
  return (
    <div>
      <div className="filter-container">
        { /* Header section*/}
        <Container>
            <Row className="filter-content">
            { /* Browse results section*/
            (from?.operation === "search" )?
                (
                  <div className="space-between">
                    <Link className="btn" to="/search">
                      <SvgIcon className="btn-icons" icon={svgIcons.arrowLeftIcon} size="medium" /><Trans>general.backToSearch</Trans>
                    </Link>
                    <div>
                      <span>{currentBatch.DocumentPositionLabel}</span>
                    {currentBatch.PreviousDocumentId && <Button className="button-margin-left-1" title={t("dataLabeling.labeling.previous")} themeColor={"secondary"} type="button" onClick={() => browseDocument(currentBatch.PreviousDocumentId as number)}><Trans>dataLabeling.labeling.previous</Trans></Button>}
                    {currentBatch.NextDocumentId ? <Button className="button-margin-left-1" title={t("dataLabeling.labeling.next")} themeColor={"primary"} type="button" onClick={() => browseDocument(currentBatch.NextDocumentId as number)} ><Trans>dataLabeling.labeling.next</Trans></Button>
                    : null}
                
                      <Button className="button-margin-left-1" title={t("dataLabeling.labeling.save")} themeColor={"primary"} type="button" onClick={saveDocument} disabled={nextStatus <= 0} >
                        <Trans>dataLabeling.labeling.completeDocument</Trans>
                      </Button>
                    </div>
                  </div>
                )
                :
                /* Batch section*/
                (<div className="space-between">
                
                <Link className="btn" to="/dashboard">
                  <SvgIcon className="btn-icons" icon={svgIcons.arrowLeftIcon} size="medium" /><Trans>general.returnToBack</Trans></Link>
                <div>
                  <span>{currentBatch.DocumentPositionLabel}</span>
                  {currentBatch.PreviousDocumentId && <Button className="button-margin-left-1" title={t("dataLabeling.labeling.previous")} themeColor={"secondary"} type="button" onClick={() => workDocument(currentBatch.PreviousDocumentId as number)}><Trans>dataLabeling.labeling.previous</Trans></Button>}
                  <Button className="button-margin-left-1" title={t("dataLabeling.labeling.skip")} themeColor={"secondary"} type="button" onClick={() => skipDocument(currentBatch.NextDocumentId as number)} ><Trans>dataLabeling.labeling.skip</Trans></Button>
                  {currentBatch.NextDocumentId ? <Button className="button-margin-left-1" disabled={nextStatus <= 0} title={t("dataLabeling.labeling.next")} themeColor={"primary"} type="button" onClick={() => nextDocument(currentBatch.NextDocumentId as number)} ><Trans>dataLabeling.labeling.next</Trans></Button>
                  : <Button className="button-margin-left-1" disabled={nextStatus <= 0} title={t("dataLabeling.labeling.completeBatch")} themeColor={"primary"} type="button" onClick={completeLastDocument}><Trans>dataLabeling.labeling.completeDocument</Trans></Button>}
                
                </div>
              
              </div>
                )
              }
            </Row>
        </Container>
      </div>
      <Row className="pt-6">
        {/* Document section */}
        <Col md={6}>
          <div style={{ position: 'relative' }}>
            <Card style={{ boxShadow: "0 0 4px 0 rgba(0, 0, 0, .1)" }}>
              <CardHeader>
                <div className="space-between">
                  {cardData.UniqueId !== "" && <span>Unique Id: {cardData.UniqueId}</span>}
                  {showDocumentChangedBadge && cardData.DocumentChanged && (
                    <span 
                      className="badge border border-warning text-warning fw-normal d-inline-flex align-items-center fs-6 me-2"
                      title={t("dataLabeling.labeling.documentContentChangedTooltip")}>
                        {t("dataLabeling.labeling.documentContentChanged")}
                      </span>
                  )}
                  <span className={getDocumentStatusBadge(cardData.Status)}>{cardData.StatusLabel}</span>
                </div>
                <div className="space-between pt-2 ">
                  <span>Id: {cardData.ProviderId}</span>
                  <span className="subtitle">{cardData.Source}</span>
                </div>
                <div className="pt-2 blogger-info">
                  <Avatar type="image" size="medium" rounded={"full"}>
                    {cardData.ThumbnailSrc && <img
                      style={{ width: 45, height: 45 }}
                      alt=""
                      src={cardData.ThumbnailSrc}
                    />}
                  </Avatar>
                  <CardTitle>{cardData.Url ? <a href={cardData.Url} target="_blank" rel="noreferrer">{cardData.Author}</a>: cardData.Author}</CardTitle>               
                </div>

                <div className="pt-2">
                  <CardSubtitle><Trans>dataLabeling.labeling.publishDate</Trans>{moment(cardData.PublishDate).format("YYYY-MM-DD")}</CardSubtitle>
                  <CardSubtitle><a href={cardData.Link} target="_blank" rel="noreferrer">{cardData.Link}</a>  </CardSubtitle>
                </div>
              </CardHeader>
              <CardBody>
              {cardData.ImagesUrls?(<ImagesGalleryComponent ImagesUrls={cardData.ImagesUrls} />):null}
                <p className="pt-2" style={{ textAlign: "justify" }}><b>{cardData.Title}</b></p>


                {cardData.Hashtags?.length > 0 || cardData.Mentions?.length > 0 || cardData.SponsoredMentions?.length > 0 || cardData.MediaMentions?.length > 0 ? (
                  <div className="wrapper">
                    <ExpansionPanel
                    title={t('dataLabeling.labeling.hashtagsMentions')}
                    subtitle={''}
                    expanded={expandedHashtagsAndMentions === t('dataLabeling.labeling.hashtagsMentions')}
                    tabIndex={0}
                    key={t('dataLabeling.labeling.hashtagsMentions')}
                    onAction={(event: ExpansionPanelActionEvent) => {
                      setExpandedHashtagsAndMentions(event.expanded ? '' : t('dataLabeling.labeling.hashtagsMentions'))
                    }}
                    >
                    <Reveal>
                      {expandedHashtagsAndMentions === t('dataLabeling.labeling.hashtagsMentions') && (
                      <ExpansionPanelContent>
                        <div className="content">
                        {cardData.Hashtags?.length > 0 ? (
                          <div className="pt-1 my-2 hashtag" style={{ textAlign: "justify" }}>
                          <p style={{ fontWeight: 'normal', marginBottom: '5px' }}>Hashtags</p>
                          <p>{cardData.Hashtags?.map((hashtag) => `#${hashtag.trim()}`).join(", ")}</p>
                          </div>
                        ) : null}
                        {cardData.Mentions?.length > 0 ? (
                          <div className="pt-1 my-2 mention" style={{ textAlign: "justify" }}>
                          <p style={{ fontWeight: 'normal', marginBottom: '5px' }}>Mentions</p>
                          <p>{cardData.Mentions?.map((mention) => `@${mention.trim()}`).join(", ")}</p>
                          </div>
                        ) : null}
                        {cardData.SponsoredMentions?.length > 0 ? (
                          <div className="pt-1 my-2 mention" style={{ textAlign: "justify" }}>
                          <p style={{ fontWeight: 'normal', marginBottom: '5px' }}>Sponsored Mentions</p>
                          <p>{cardData.SponsoredMentions?.map((mention) => `@${mention.trim()}`).join(", ")}</p>
                          </div>
                        ) : null}
                        {cardData.MediaMentions?.length > 0 ? (
                          <div className="pt-1 my-2 mention" style={{ textAlign: "justify" }}>
                          <p style={{ fontWeight: 'normal', marginBottom: '5px' }}>Media Mentions</p>
                          <p>{cardData.MediaMentions?.map((mention) => `@${mention.trim()}`).join(", ")}</p>
                          </div>
                        ) : null}
                        </div>
                      </ExpansionPanelContent>
                      )}
                    </Reveal>
                    </ExpansionPanel>
                  </div>
                ) : null}

                <p className="pt-2" style={{ textAlign: "justify" }}>{cardData.Content}</p>
                {cardData.AudioToText?(
                  <div className="wrapper">
                    <ExpansionPanel
                      title={t('general.subtitle')}
                      subtitle={''}
                      expanded={expandedTextToSpeech === t('general.subtitle')}
                      tabIndex={0}
                      key={t('general.subtitle')}
                      onAction={(event: ExpansionPanelActionEvent) => {
                        setExpandedTextToSpeech(event.expanded ? '' : t('general.subtitle'))
                      }}
                    >
                      <Reveal>
                        {expandedTextToSpeech === t('general.subtitle') && (
                          <ExpansionPanelContent>
                            <div className="content">
                            <p className="pt-2">
                              <span className="transcription">{cardData.AudioToText}</span>
                            </p>
                            </div>
                          </ExpansionPanelContent>
                        )}
                      </Reveal>
                    </ExpansionPanel>
                  </div>
                  ):null}
                  {cardData.AuthorComments?(
                    <ExpansionPanel
                    title={t('general.authorComments')}
                    subtitle={''}
                    expanded={expandedComments === t('general.authorComments')}
                    tabIndex={0}
                    key={t('general.authorComments')}
                    onAction={(event: ExpansionPanelActionEvent) => {
                      setExpandedComments(event.expanded ? '' : t('general.authorComments'))
                    }}
                  >
                    <Reveal>
                      {expandedComments === t('general.authorComments') && (
                        <ExpansionPanelContent>
                          <div className="content">
                          <p className="pt-2 bg-light rounded w-100">
                            <span className="mb-0 text-muted">{cardData.AuthorComments}</span>
                          </p>
                          </div>
                        </ExpansionPanelContent>
                      )}
                    </Reveal>
                  </ExpansionPanel>
                  ):null}
              </CardBody>
            </Card>
            {isCardDataLoading && (
              <div className="spinner-overlay">
                <span className="k-icon k-i-loading k-spin" style={{ fontSize: "48px" }}></span>
              </div>
            )}
          </div>
        </Col>
        {/* Annotation section */}
        <Col md={6}>
          <div className="tile-content" id="labeling">
            <ODataProvider baseUrl={annotationsApiUrl} loadingContent=".k-grid-content">
              <div style={{ position: 'relative' }}>
                              <DataGridCustom autoBind={false} onDataStateChange={handelDataStateChange} PermissionButtonCode="menu_datalabeling" ShowAddButton={true} PageSize={annotationsGridPageSize} enablePagination={false} onAddButtonClick={handleNew} ref={dataGridRef} DataItemKey="AnnotationId" Columns={columns}  editField={editField} onRowClick={handleRowClick} />
                {isAnnotationChangeLoading && (
                  <div className="spinner-overlay">
                    <span className="k-icon k-i-loading k-spin" style={{ fontSize: "48px" }}></span>
                  </div>
                )}
              </div>
            </ODataProvider>
          </div>
        </Col>
      </Row>
      <ConfirmModal show={show} setShow={setShow} handleConfirm={handleConfirm} valueSearch={selectedAnnotationId} title="general.titleRemoveMessage" message="general.removeMessage" onClose={()=>setShow(false)} />
      {location.state?.from.operation !== "missing" && (
        <ConfirmModal show={showNextBatch} setShow={setShowNextBatch} handleConfirm={()=>handleNextBatchConfirm(from.batchId)} title="dataLabeling.labeling.startNewBatch" message="dataLabeling.labeling.messageStartNewBatch" onClose={handleCloseNextBatch}/>
      )}
      {openForm && (
        <WindowLabeling autoBind={formMode!=="edit"} isDropDownDisabled={isDropDownDisabled && formMode==="edit"} preventCompleteDocWithoutLabel={projectStatus === 'ready' ? activeProject?.PreventCompleteDocWithoutLabel : undefined} entityApiUrl={entityApiUrl} labelApiUrl={labelApiUrl} cancelEdit={handleCancelEdit} onSubmit={handleSubmit} item={editItem} />
      )}
      {showComments && (
        <CommentSection onClose={closeCommentsWindow} existingComments={comments} typeId={typeId} annotationIdProp={selectedAnnotationId} documentIdProp={documentId} />
      )}
      {showMetadata && (
        <MetadataSection onClose={closeMetadataWindow} metaData={metadata} />
      )}
      {showAuditHistory && (
        <AuditEntryModal onClose={closeAuditHistoryWindow} auditEntriesModel={auditHistory} />
      )}
      

    </div>
  )

};

function getInlineDropDownProps(entityApiUrl: string, fieldValue: string, fieldName: string, handleChange: (e: any) => void, selectedItem: any, lockEntityEdit: boolean, filterField: string, filterValue: string, autoBind: boolean, gridProps: GridCellProps, dropDownEntityRef:any ): any {
  return {
    sourceApiUrl: entityApiUrl,
    fieldValue: fieldValue,
    fieldName: fieldName,
    onChange: handleChange,
    selectedItem: selectedItem,
    disableDropDown: lockEntityEdit,
    filterField: filterField,
    filterValue: filterValue,
    autoBind: autoBind,
    gridProps: gridProps,
    ref: dropDownEntityRef
  };
}

export default Labeling;